module.exports = __webpack_public_path__ + "img/1.5e8121e8.png";